import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRequest =
        error.config?.url?.includes('/login') ||
        error.config?.url?.includes('/register');
      if (!isAuthRequest) {
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const siteService = {
  getSites: async () => {
    const response = await api.get('/sites');
    return response.data;
  },
  getSite: async (id) => {
    const response = await api.get(`/sites/${id}`);
    return response.data;
  },
  createSite: async (data) => {
    const response = await api.post('/sites', data);
    return response.data;
  },
  updateSite: async (id, data) => {
    const response = await api.put(`/sites/${id}`, data);
    return response.data;
  },
  deleteSite: async (id) => {
    const response = await api.delete(`/sites/${id}`);
    return response.data;
  },
};
